<template lang="pug">
v-container(fluid)
    #map
    .absolute(style="pointer-events:none")
</template>

<script>
import mapboxgl from 'mapbox-gl';
import U from 'mapbox-gl-utils';
import { EventBus } from '../EventBus';
import 'mapbox-gl/dist/mapbox-gl.css';
import initLocations from './layers/locations';
import initResultPins from './layers/resultPins';
import { loadFigmassets, loadStoredFigmassets } from 'figmasset';
import { initGeocoder } from './geocoder';
export default {
    data: () => ({
        filter: null,
        selectedId: null,
    }),
    async mounted() {
        // replace this Mapbox access token with your own
        mapboxgl.accessToken =
            'pk.eyJ1IjoibGVhay1teS1icmFpbiIsImEiOiJsYzNWV1E0In0.R0Y5eCKCP6j7VNaqsYaO8w';
        this.initMap('map');
        window.app.Map = this;
    },
    methods: {
        async initMap() {
            mapboxgl.accessToken =
                'pk.eyJ1Ijoia2ltYmVybGV5c3VwcG9ydHMiLCJhIjoiY2txcnB0ZXBxMWUyeTJ2cDVrMnlwZjg1YyJ9.TMYfjSsKhfbpe7gIHl9SrQ';

            this.map = new mapboxgl.Map({
                container: 'map',
                // center: [122.773, -20.468],
                // zoom: 6.7,
                bounds: [
                    117.58863683065857,
                    -20.35388700617372,
                    129.14678971758326,
                    -13.657869582002988,
                ],
                // maxBounds: [
                //     117.58863683065857,
                //     -20.35388700617372,
                //     129.14678971758326,
                //     -13.657869582002988,
                // ],
                style:
                    'mapbox://styles/kimberleysupports/ckqu78zjo0ka418qe55r1ae7u',
                dragRotate: false,
                maxPitch: 0,
                pitchWithRotate: false,
                maxZoom: 17,
                minZoom: 5,
                // hash: 'centre',
            });
            // this.map.dragRotate.disable();
            this.map.touchZoomRotate.disableRotation();
            window.map = this.map;
            initGeocoder(this.map);
            this.map.addControl(
                new mapboxgl.NavigationControl({ showCompass: false })
            );
            U.init(this.map, mapboxgl);

            await this.map.U.onLoad();
            this.map.resize();
            this.loadAssets(this.map);
            this.addLayers(this.map);

            EventBus.$on('filter-change', (filter) => {
                this.filter = filter;
                this.addLayers();
            });
            EventBus.$on('results-bbox', (bbox) => {
                this.map.fitBounds(bbox, {
                    padding: { top: 100, bottom: 100, left: 50, right: 50 },
                });
                // this.map.U.addGeoJSON('bounds', turf.bboxPolygon(bbox));
                // this.map.U.addLine('bounds-line', 'bounds', {
                //     lineColor: 'magenta',
                // });
            });
            EventBus.$on('result-click', (result) => {
                // how do we store the result when it might be multiple?
                this.selectedId = result.firstServiceId;
                initResultPins(this.map, {
                    categories: this.filter,
                    selectedId: this.selectedId,
                });
            });
        },
        addLayers() {
            // labels for communities
            initLocations(this.map, { categories: this.filter });

            // result pins
            initResultPins(this.map, { categories: this.filter });
        },

        async loadAssets(map) {
            loadStoredFigmassets({ map, path: 'assets@2x' });
        },
    },
};
</script>

<style>
#map {
    position: absolute;
    width: 100%;
    top: 0;
    bottom: 0;
}
.mapboxgl-ctrl-geocoder {
    width: 100%;
    max-width: 100%;
}
</style>
